import {register} from '../modules/eventMap';

function print() {
    window.print();
}

const printer = () => {
    register('printer', {
        print
    });
};

export {printer};
